import { motion } from "framer-motion";
import { ChalkboardTeacher, Barbell, Palette, ShieldCheck } from "@phosphor-icons/react";

const PROGRAMS = [
  {
    n: "P.01",
    icon: ChalkboardTeacher,
    title: "Teach for Primary Fellowship",
    body: "Trained fellows step into government classrooms where teachers are stretched thin. At MPUP Gandipet, the student-teacher ratio improved from 1:110 to 1:66 in a single year.",
  },
  {
    n: "P.02",
    icon: Barbell,
    title: "FitED Fellowship",
    body: "ZPHS Mazeedpura had no Physical Education Teacher for years. Our PET fellow brought back sports, drills, and movement-based learning — restoring fitness and team spirit.",
  },
  {
    n: "P.03",
    icon: Palette,
    title: "Activity-Based Classrooms",
    body: "Learning through creativity, exploration, and joy. Summer Camp 2025 took 40+ children through art, music, maths and science — ending in a live showcase at Prasads IMAX.",
  },
  {
    n: "P.04",
    icon: ShieldCheck,
    title: "Community & Digital Safety",
    body: "Cyber-safety sessions for 1,300+ students, Gurukul & Navodaya orientation for parents, and our Sunday Classroom in Sangareddy — learning beyond school walls.",
  },
];

export const Programs = () => (
  <section id="programs" className="py-24 lg:py-32" data-testid="programs-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-terra" data-testid="programs-eyebrow">What We Do</span>
          <h2 className="font-serif font-bold tracking-tighter text-forest text-4xl sm:text-5xl lg:text-6xl mt-4" data-testid="programs-heading">
            Programs that carry <span className="italic text-terra">light</span> further.
          </h2>
        </motion.div>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-5 text-base leading-relaxed text-moss"
        >
          Three programs, one goal: make sure no child's education depends on their
          pin code. Each one is funded directly by people like you.
        </motion.p>
      </div>

      <div className="grid lg:grid-cols-12 gap-8 items-stretch">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -inset-0 -translate-x-4 translate-y-4 bg-forest -z-0" />
          <img
            src="/photos/paint-prep.jpg"
            alt="LLI volunteers mixing paints for a school transformation day"
            className="relative w-full h-full min-h-[380px] object-cover img-warm border border-forest/20"
            data-testid="programs-image"
          />
        </motion.div>

        <div className="lg:col-span-7 grid gap-0 border border-forest/20 divide-y divide-forest/20 bg-bone">
          {PROGRAMS.map((p, i) => (
            <motion.article
              key={p.n}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="p-8 lg:p-10 flex gap-6 items-start hover:bg-bonealt/70 transition-colors duration-300 group"
              data-testid={`program-card-${p.n.replace(".", "").toLowerCase()}`}
            >
              <span className="text-forest/30 font-serif font-bold text-lg pt-1">{p.n}</span>
              <div className="flex-1">
                <div className="flex items-center gap-3">
                  <p.icon size={26} weight="duotone" className="text-terra" />
                  <h3 className="font-serif font-bold text-2xl text-forest tracking-tight">{p.title}</h3>
                </div>
                <p className="mt-3 text-base leading-relaxed text-moss max-w-lg">{p.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  </section>
);
